import React from 'react';

const UnsupportedContent: React.FC = () => {
    return (
        <div className="text-center">
            <p>Your browser does not support media recording.</p>
            <p>Please try using a modern browser like Chrome, Firefox, or Edge.</p>
        </div>
    );
};

export default React.memo(UnsupportedContent);
